<template>
  <v-layout>
    <v-layout>
      <v-flex>
        <v-progress-circular
          v-if="loading"
          indeterminate
          class="primary--text"
          :width="7"
          :size="10"
        />
      </v-flex>
    </v-layout>
    <v-layout v-if="!loading">
      <v-card
        v-for="video in videos"
        :key="video.id"
        class="mx-auto my-12"
        max-width="374"
      >
        <v-img
          height="250"
          contain
          :src="video.imageUrl"
        />

        <v-card-title>{{ video.title }}</v-card-title>

        <v-card-text>
          <v-row
            align="center"
            class="mx-0"
          >
            <v-rating
              :value="4.5"
              color="amber"
              dense
              half-increments
              readonly
              size="14"
            />

            <div class="grey--text ml-4">
              4.5 (413)
            </div>
          </v-row>

          <div class="my-4 subtitle-1">
            Beginner • {{ video.date | date }}
          </div>

          <div>50 mins barre and 10 mins of center.</div>
        </v-card-text>

        <v-divider class="mx-4" />

        <v-card-title>Tags</v-card-title>

        <v-card-text>
          <v-chip-group
            column
          >
            <v-chip>Turnout</v-chip>
            <v-chip>Feet</v-chip>
          </v-chip-group>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="deep-purple lighten-2"
            text
            router
            :to="'/video/' + video.id"
          >
            View More
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-layout>
</template>

<script>
  export default {
    computed: {
      videos () {
        return this.$store.getters.loadedVideos
      },
      loading () {
        return this.$store.getters.loading
      }
    }
  }
</script>
